import { Outlet } from 'react-router-dom';
import { useAuth } from '../api.js';
import { BUILD } from '../version.js';
import { TopNav } from './TopNav.js';

function ImpersonationBanner() {
  const { impersonating, impersonatedEmail, impersonatedBy, exitImpersonation } = useAuth();
  if (!impersonating) return null;
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950">
      <span>
        Support session — viewing as{' '}
        <span className="font-semibold">{impersonatedEmail ?? 'this user'}</span>
        {impersonatedBy ? ` (${impersonatedBy})` : ''} · read-only
      </span>
      <button
        type="button"
        onClick={exitImpersonation}
        className="rounded bg-amber-950/10 px-2 py-0.5 font-semibold underline-offset-2 hover:bg-amber-950/20"
      >
        Exit
      </button>
    </div>
  );
}

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 dark:bg-neutral-950">
      <ImpersonationBanner />
      <TopNav />

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6 sm:px-6">
        <Outlet />
      </main>

      <footer className="border-t border-neutral-200/70 px-4 py-3 text-center text-xs text-neutral-400 dark:border-neutral-800/70 sm:px-6">
        © {new Date().getFullYear()} CommissionSight · Patent Pending · app{' '}
        <span className="font-mono">{BUILD.version}</span> · built {BUILD.date}
      </footer>
    </div>
  );
}
